/**
 * Card Utilities
 * For use with linking a card
 *
 * - get card type [visa, mastercard, amex, discover, maestro, unionpay] based on the card number
 */


export const defaultCardSpec = {
	type: 'card',
	fields: {
		ccNumber: {
			required: true,
			pattern: '4[0-9]{12}(?:[0-9]{3})?',
			maxlength: 19
		},
		expirationDate: {
			required: true,
			pattern: '(0[1-9]|1[012])[/]((20)[0-9]{2}|[0-9]{2})',
			maxlength: 7
		},
		csc: {
			required: true,
			pattern: '[0-9]*',
			maxlength: 3,
			minlength: 3
		}
	}
};

/**
 * Get the card type based on the card number
 * @param {Object} cardSpecs - the card specifications based on user's locale
 * @param {String} cardNumber - the valid card number (numbers only)
 * @return {Object} cardType - the card type specs for a specific card
 */
export function getSpecificCardSpec({ cardTypes }, cardNumber) {
	cardNumber = cardNumber.replace(/\D+/g, '');

	for (let card in cardTypes) {
		let cardSpec = cardTypes[card];
		if (new RegExp(`^${cardSpec.fields.ccNumber.autodetect}$`).test(cardNumber)) {
			return cardSpec;
		}
	}
	return defaultCardSpec;
}